/** true, wenn im Betriebssystem "Bewegung reduzieren" aktiviert ist */
export const prefersReducedMotion = () =>
	window.matchMedia('(prefers-reduced-motion: reduce)').matches;
